export default __webpack_public_path__ + "static/travel-hero-bg-high-res-5f9337b685826949ea796325e809b25f.jpg";